import React from 'react';
import './Loader.css';

const Loader = ({ 
  size = 'medium', 
  color = 'primary',
  text,
  fullscreen = false
}) => {
  const loader = (
    <div className={`loader-container ${fullscreen ? 'fullscreen' : ''}`}>
      <div className={`loader ${size} ${color}`}></div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
  
  if (fullscreen) {
    return <div className="loader-overlay">{loader}</div>;
  }
  
  return loader;
};

export default Loader;